export default "__VITE_ASSET__YVUUcVaV__"